export default "__VITE_PUBLIC_ASSET__e348c245__"